import useAxiosService from './useAxiosService'
import { IResponse } from 'interfaces/services'
import {
  IPaymentWithdrawalInquiry,
  IWalletInfo
} from 'pages/patientTransaction/interfaces'

const useTransactionService = () => {
  const { get, post } = useAxiosService()

  const getWalletInfo = async () => {
    const res = await get('/clinic/wallet/')
    return res as IResponse<IWalletInfo>
  }

  const postPaymentWithdrawalInquiry = async (
    query: IPaymentWithdrawalInquiry
  ) => {
    const res = await post('/payment/withdrawal/inquiry', query)
    return res as IResponse<any>
  }

  const postWithdrawalConfirm = async (transactionId: string) => {
    const res = await post('/payment/withdrawal/confirm', {
      transaction_group_uuid: transactionId
    })
    return res as IResponse<any>
  }

  return { getWalletInfo, postPaymentWithdrawalInquiry, postWithdrawalConfirm }
}

export default useTransactionService
